import React from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import DynamicIndex from './components/DynamicIndex';
import DynamicIndexDemo from './components/DynamicIndexDemo';
import ProcessPage from './components/ProcessPage';
import ProcessPageDemo from './components/ProcessPageDemo';
import Auth, { AuthProvider, useAuth } from './components/Auth';
import LoginPage from './components/LoginPage';
import StatusIndicator from './components/StatusIndicator';
import DebugPanel from './components/DebugPanel';
import Navigation from './components/Navigation';
import Header from './components/Header';

// Protected Routes Component
const ProtectedApp = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div className="spinner" style={{ width: '32px', height: '32px' }}></div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div className="App">
      <Header />
      
      <Routes>
        <Route path="/" element={<DynamicIndex />} />
        <Route path="/demo" element={<DynamicIndexDemo />} />
        <Route path="/technical-processes/:processName" element={<ProcessPage />} />
        <Route path="/operational-procedures/:processName" element={<ProcessPage />} />
        <Route path="/onboarding-documentation/:processName" element={<ProcessPage />} />
        <Route path="/knowledge-base/:processName" element={<ProcessPage />} />
        <Route path="/demo/technical-processes/:processName" element={<ProcessPageDemo />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <ProtectedApp />
      </Router>
    </AuthProvider>
  );
}

export default App;